import type { JSONContent } from "@tiptap/core";
import type { TWebsiteBuilderElementType } from "../nodes/element/websiteBuilderElement";
import { TWebsiteBuilderRichTextResponsiveFontSize, websiteBuilderNormalizeRichTextResponsiveFontSize } from "./extensions/websiteBuilderRichTextResponsiveFontSize";

export type TWebsiteBuilderRichTextType = Extract<TWebsiteBuilderElementType, "heading" | "paragraph">;

export type TWebsiteBuilderRichTextContent = JSONContent & {
  type: "doc";
  attrs: {
    responsiveFontSize: TWebsiteBuilderRichTextResponsiveFontSize;
  };
};

export function websiteBuilderNormalizeRichTextContent(content: JSONContent): TWebsiteBuilderRichTextContent {
  return {
    ...content,
    type: "doc",
    attrs: {
      ...content.attrs,
      responsiveFontSize: websiteBuilderNormalizeRichTextResponsiveFontSize(content.attrs?.responsiveFontSize),
    },
  };
}
